import React, { PureComponent } from 'react';
import { Radio, Form } from 'antd';
import { FormContext } from '../context';

export default class FormItemsContainer extends PureComponent {
    static contextType = FormContext;
    render() {
        const { label, required, className, condition } = this.props;
        const { form } = this.context;
        const values = form.getFieldsValue();
        if (condition) {
            if (!condition(values)) {
                return <></>;
            }
        }
        return (<div className={"" + className + (required ? " required" : "")} >
            {!!label && <label className="ant-form-item-label">{label}</label>}
            <div className="">{this.props.children}</div>
        </div>)
    }

}


